import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import VideoShowcase from '../components/VideoShowcase';
import SEO from '../components/SEO';
import HeroSection from '../components/home/HeroSection';
import OfferSection from '../components/home/OfferSection';
import ResultsMetrics from '../components/home/ResultsMetrics';
import CtaBanner from '../components/home/CtaBanner';
import HowItWorks from '../components/home/HowItWorks';
import WhoItsFor from '../components/home/WhoItsFor';
import Testimonials from '../components/home/Testimonials';
import FAQSection from '../components/home/FAQSection';
import { FinalCTA, LocationsBar, StickyCTA } from '../components/home/FinalCTA';
import ExitIntentPopup from '../components/ExitIntentPopup';
import SocialProofTicker from '../components/SocialProofTicker';
import WhatsAppButton from '../components/WhatsAppButton';

const HomePage = () => {
  const { t } = useTranslation();
  const banners = t('home.ctaBanners', { returnObjects: true });

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <SEO />
      <Header />
      <main>
        <HeroSection />
        <OfferSection />
        <ResultsMetrics />
        <CtaBanner text={banners.afterResults.text} buttonText={banners.afterResults.button} subtext={banners.afterResults.sub} />
        <VideoShowcase />
        <CtaBanner text={banners.afterVideos.text} buttonText={banners.afterVideos.button} />
        <HowItWorks />
        <WhoItsFor />
        <Testimonials />
        <FAQSection />
        <FinalCTA />
        <LocationsBar />
      </main>
      <Footer />
      <StickyCTA />
      <WhatsAppButton />
      <SocialProofTicker />
      <ExitIntentPopup />
    </div>
  );
};

export default HomePage;
